import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Http, HttpModule } from "@angular/http";
import { TranslateModule,TranslateLoader, TranslateStaticLoader  } from 'ng2-translate';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AnimateOnScrollModule } from 'ng2-animate-on-scroll';
import { Ng2PageScrollModule } from 'ng2-page-scroll';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



// RUTAS
import { app_routing } from "./app.routes";

//SERVICIOS
import { InformacionService } from "./services/informacion.service";
import { ProductosService } from "./services/productos.service";

//COMPONENTES
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { MainComponent } from './components/main/main.component';
import { BiografiaComponent } from './components/biografia/biografia.component';
import { ProcesoComponent } from './components/proceso/proceso.component';
import { ObrasComponent } from './components/obras/obras.component';
import { OrganeriaComponent } from './components/organeria/organeria.component';
import { ContactoComponent } from './components/contacto/contacto.component';
import { ScrollDirective } from './scroll.directive';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MainComponent,
    BiografiaComponent,
    ProcesoComponent,
    ObrasComponent,
    OrganeriaComponent,
    ContactoComponent,
    ScrollDirective
  ],
  imports: [
    BrowserModule,
    HttpModule,
    app_routing,
    TranslateModule.forRoot({
              provide: TranslateLoader,
              useFactory: function(http: Http){ return new TranslateStaticLoader(http, '/assets/i18n', '.json') },
              deps: [Http]
          }),
    ModalModule.forRoot(),
    AnimateOnScrollModule.forRoot(),
    Ng2PageScrollModule,
    NgbModule.forRoot(),

  ],
  providers: [InformacionService, ProductosService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/administrador/Trabajos/pascal3/src/app/app.module.ts